import * as React from "react";
import type { SVGProps } from "react";
const SvgEuroCoinInSlot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.36 16.93A3.8 3.8 0 0 1 11.74 18c-1.657 0-3.089-1.142-3.772-2.8H7.74a1 1 0 0 1-.196-1.98 6 6 0 0 1 0-.44 1 1 0 0 1 .196-1.98h.228C8.65 9.142 10.083 8 11.74 8a3.8 3.8 0 0 1 2.6 1.07A1 1 0 0 1 13 10.53a1.84 1.84 0 0 0-1.26-.53c-.562 0-1.084.306-1.478.8h.678a1 1 0 1 1 0 2H9.545a4 4 0 0 0 0 .4h1.395a1 1 0 0 1 0 2h-.682c.393.494.915.8 1.482.8a1.84 1.84 0 0 0 1.26-.53 1 1 0 0 1 1.36 1.46"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.981 20H22a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-1.226a9 9 0 1 0-17.548 0H2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4.504a1 1 0 0 0 .477 0m12.5-2q.322-.48.58-1H21v1zM3.87 17q.034 0 .068-.002.258.519.58 1.002H3v-1zm1.336-2.313A7 7 0 0 0 7.101 18H16.9a7 7 0 1 0-11.693-3.313"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEuroCoinInSlot;
